import {
   GET_CONCEPTS,
   CHANGE_INPUT_VALUE_CONCEPT,
   SAVE_CONCEPT,
   GET_ITEM_CONCEPT,
   DELETE_CONCEPT,
   CONCEPT_DEFAULT_DATA
} from '../constants/concepts';

export const concepts = ( state = {}, action ) => {
   switch ( action.type ) { 

      case GET_CONCEPTS : {
         return action.payload;
      }

      case CHANGE_INPUT_VALUE_CONCEPT : {
         return action.payload;
      }

      case SAVE_CONCEPT : {
         return action.payload;
      }

      case GET_ITEM_CONCEPT : {
         return action.payload;
      }

      case DELETE_CONCEPT : {
         return action.payload;
      }

      case CONCEPT_DEFAULT_DATA : {
         return action.payload;
      }
 
     default :
     return state;
   }
}